import { render } from "./glocalizing-our-practices.vue?vue&type=template&id=0e76d6d3&scoped=true"
import script from "./glocalizing-our-practices.vue?vue&type=script&lang=js"
export * from "./glocalizing-our-practices.vue?vue&type=script&lang=js"

import "./glocalizing-our-practices.vue?vue&type=style&index=0&id=0e76d6d3&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e76d6d3"]])

export default __exports__